module.exports = __webpack_public_path__ + "static/img/bg-fr.9a9a1910.png";